import React from 'react';
import { identity } from 'lodash';
import { TableProps } from './Table.config';
import { TableCell } from './TableCell';
import { Column } from '../NewStrategy/StrategyTable';
import { Sort } from '../NewStrategy/Sort';

function getTableHeaderJSX({
  columns,
  width,
  type,
  handleSort,
}: Pick<TableProps, 'columns' | 'width' | 'type' | 'handleSort'>) {
  return columns
    .filter((col) => (width === 1 ? col.fixed : true))
    .map((col, pos) => {
      return (
        <TableCell position={pos} width={width}>
          <Column
            className={`flex items-center w-full h-full border-grey-10 dark:border-grey-70`}
            element={
              <Sort
                className={` flex items-center text-sm ${
                  !pos && 'pl-3'
                } font-medium w-full h-full`}
                columnName={col.t}
                columnLabel={col.label}
                columnClassName={'uppercase'}
                key={col.t}
                type={type || ''}
                handleSort={handleSort || identity}
              />
            }
            span={1}
          />
        </TableCell>
      );
    });
}

function getTableBodyJSX({
  data,
  width,
  handleClick,
  contentClassName,
}: Pick<TableProps, 'data' | 'width' | 'handleClick' | 'contentClassName'>) {
  return data.map((element, p) => {
    return element.data.map((el, position) => {
      return (
        <TableCell
          width={width}
          position={position}
          key={`table-data_${position}`}
          className={`
          ${!position && width > 1 && 'border-r'}
          h-15
          ${contentClassName} 
        `}
          onClick={() => handleClick(element.extendedProps)}
        >
          {el}
        </TableCell>
      );
    });
  });
}

export { getTableHeaderJSX, getTableBodyJSX };
